interface ActivityCardInterface {
  name: string;
  img?: any; // Accepting the object structure you provided
  selected?: boolean;
  onClick?: () => void;
}

export default function PupilCard({
  name,
  img,
  selected,
  onClick,
}: ActivityCardInterface) {
  // EXTRACTION LOGIC:
  // If img is an object with props, get the src. Otherwise, assume it's a string URL.
  const imageSource = img?.props?.src || (typeof img === "string" ? img : null);

  return (
    <div
      onClick={onClick}
      className={`relative flex flex-col items-center p-3 rounded-[2rem] border-2 transition-all duration-300 cursor-pointer w-[110px] sm:w-[140px] group
        ${
          selected
            ? "border-blue-600 bg-blue-50 shadow-lg shadow-blue-900/10 scale-105"
            : "border-transparent bg-white hover:border-slate-200 shadow-sm"
        }
      `}
    >
      {/* Animated Selection Checkmark */}
      <div
        className={`absolute top-2 right-2 w-6 h-6 rounded-full flex items-center justify-center transition-all duration-300 z-20
        ${selected ? "bg-blue-600 scale-100 rotate-0" : "bg-slate-200 scale-0 -rotate-90"}
      `}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-3 w-3 text-white"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={4}
            d="M5 13l4 4L19 7"
          />
        </svg>
      </div>

      {/* Avatar Container with Glass Effect background */}
      <div className="relative w-20 h-20 sm:w-24 sm:h-24 mb-3">
        <div
          className={`absolute inset-0 rounded-full blur-md opacity-20 transition-opacity group-hover:opacity-40 ${selected ? "bg-blue-600" : "bg-slate-400"}`}
        />

        <div
          className={`relative w-full h-full rounded-full overflow-hidden border-4 transition-transform duration-500 group-hover:rotate-3
          ${selected ? "border-blue-200" : "border-white"}
        `}
        >
          {imageSource ? (
            <img
              src={imageSource}
              alt={name}
              className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
            />
          ) : (
            <div className="w-full h-full flex items-center justify-center bg-gradient-to-br from-slate-100 to-slate-200 text-slate-400 font-bold text-2xl">
              {name.charAt(0)}
            </div>
          )}
        </div>
      </div>

      {/* Name with improved typography */}
      <p
        className={`text-center font-black tracking-tight text-[11px] sm:text-xs truncate w-full px-1 transition-colors
        ${selected ? "text-blue-900" : "text-slate-600"}
      `}
      >
        {name.toUpperCase()}
      </p>
    </div>
  );
}
